import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const SWISH: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Swish,
    name: 'swish',
    displayName: 'Swish'
};
